class LeadService {

  public static get phoneMask() {
    return ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]
  }

  public static removePhoneMask(phone: string) {
    return phone.replace(/\D/g, '')
  }
}

export default LeadService
